import { render, staticRenderFns } from "./ModalInfoProduto.vue?vue&type=template&id=287aef02&scoped=true&"
import script from "./ModalInfoProduto.vue?vue&type=script&lang=js&"
export * from "./ModalInfoProduto.vue?vue&type=script&lang=js&"
import style0 from "./ModalInfoProduto.vue?vue&type=style&index=0&id=287aef02&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287aef02",
  null
  
)

export default component.exports